import React from 'react';
import { styled } from '@mui/material';

import { useViewport } from 'contexts/viewport';
import { Button, Stack, Text } from 'shell/components';

const FinishedSurvey = ({ handleClickToReview, handleClickToCourseDashboard }) => {
    const { device } = useViewport();

    return (
        <RootStack alignItems={'center'} device={device} spacing={10}>
            <Stack alignItems={'center'} spacing={4}>
                <Text align={'center'} variant={'h6'} weight={'semibold'}>
                    Thank you for submitting your course intake form!
                </Text>
                <Text align={'center'} variant={'p1'}>
                    You will receive access to the team dashboard once the instructor has set-up your team.
                </Text>
                <Button
                    sx={{ width: 'fit-content' }}
                    color={'neutral'}
                    variant={'tertiary'}
                    onClick={handleClickToReview}
                >
                    View Course Intake Form
                </Button>
            </Stack>
            <Button sx={{ width: 'fit-content' }} onClick={() => handleClickToCourseDashboard()}>
                Back to Courses
            </Button>
        </RootStack>
    );
};

const RootStack = styled(Stack)(({ theme }) => {
    return {
        marginTop: theme.spacing(10),
    };
});

export default FinishedSurvey;
